import React, { useEffect } from "react";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import * as VisuallyHidden from "@radix-ui/react-visually-hidden";
import { ButtonSize, RegularButton } from "@/stories/button/button";
import { AlertCircle } from "lucide-react";
import useMobile from "@/app/hooks/use-mobile";
import { setAnalyticsEvent } from "@/app/utils/SetAnalyticsEvent";
import { useCleverTapEvents } from "@/app/hooks/use-clevertap";
// import { initBranch, trackEvent } from "@/app/utils/branchio";

interface PaymentStepProps {
    isAdvisoryFlow?: boolean;
    onComplete: () => void;
}

const FailedModal: React.FC<PaymentStepProps> = ({ onComplete, isAdvisoryFlow }) => {
    const handleRedirect = () => onComplete();
    const { isMobile } = useMobile();
    const { cleverTapTrackEvent } = useCleverTapEvents();

    useEffect(() => {
        setAnalyticsEvent("", `US_Payment_Failed`);
        cleverTapTrackEvent(`US_Payment_Failed`, {});
        // initBranch()
        //     .then(() => {
        //         trackEvent(`US_Payment_Failed`);
        //     })
        //     .catch((error) => console.error("Error initializing Branch:", error));
    }, []);

    return (
        <Dialog open={true}>
            <DialogContent className="w-[90%] !rounded-3xl p-6 md:w-[460px] md:p-9 [&>button:last-child]:hidden">
                <VisuallyHidden.Root>
                    <DialogTitle>Failed Modal</DialogTitle>
                </VisuallyHidden.Root>
                <div className="w-full">
                    <AlertCircle className="m-auto h-8 w-8 text-red-500" />
                    <div className="w-full text-center text-xl font-semibold">
                        <div className="flex flex-col items-center justify-center py-3">
                            Payment failed
                        </div>
                    </div>
                    <div className="flex-center flex flex-col items-center">
                        {/* <div className="h-52 w-52"><Lottie animationData={Failed} loop={false}/></div> */}
                        <p className="w-full text-center text-md">
                            Your order was not placed successfully!
                        </p>
                    </div>
                </div>
                {!isAdvisoryFlow && <RegularButton
                    className="mt-5 max-w-full text-lg md:mt-8"
                    label="Retry"
                    noIcon={true}
                    showRightIcon={false}
                    onClick={handleRedirect}
                    size={isMobile ? ButtonSize.Small : ButtonSize.Large}
                />}
            </DialogContent>
        </Dialog>
    );
};

export default FailedModal;
